import { message, PageHeader, Popconfirm, Select, Space, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { SegmentedItem, SelectInsumosItem, SelectItem, TableItem, round10Decimals, ButtonItem } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import VerAgrupacion from "./VerAgrupacion/VerAgrupacion";
import EditarAgrupacion from "./EditarAgrupacion/EditarAgrupacion";

moment.locale("es");

const { Option } = Select;

class Agrupaciones extends Component {
    state = {
        loading: false,
        objetoProyectos: [],
        todasProyectos: [],
        objetoInsumos: [],
        todasInsumos: [],
        todasLotes: [],
        proyectoId: 0,
        insumoId: null,
        modalVerAgrupacion: false,
        modalVerAgrupacionId: null,
        modalEditarAgrupacion: false,
        modalEditarAgrupacionId: null,
        valor: 1, // 1: Activos, 2: Ocupados, 3: Todos
    };

    async componentDidMount() {
        this.setState({ loading: true });
        await axios
            .post(
                "proyectos/selectProyectos",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    this.setState({ todasProyectos: res.data });
                    this.setState({
                        objetoProyectos: res.data.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                    });
                }
            });
        await this.consultarAgrupacionesInsumo(this.state.valor)
        this.setState({ loading: false });
    }

    async consultarAgrupacionesInsumo(value) {
        this.setState({ loading: true });
        await axios
            .post(
                "agrupaciones/selectAgrupacionesInsumos",
                { empresaId: this.props.empresaId, insumoId: this.state.insumoId, proyectoId: this.state.proyectoId, valor: value },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasLotes: res.data.lotes,
                        loading: false,
                    });
                } else {
                    this.setState({ todasLotes: [], loading: false })
                    message.info("No se encontraron lotes para este insumo y proyecto.");
                }
            });
    }

    onChangeProyectoInsumo(insumoId, proyectoId) {
        this.setState({ loading: true })
        axios
            .post(
                "agrupaciones/selectAgrupacionesInsumos",
                { empresaId: this.props.empresaId, insumoId, proyectoId, valor: this.state.valor },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasLotes: res.data.lotes
                    });
                } else {
                    this.setState({ todasLotes: [] })
                    message.info("No se encontraron agrupaciones para este insumo y proyecto.");
                }
                this.setState({ loading: false, insumoId, proyectoId });
            });

    }

    handleMenuClick(e) {
        if (e.key === '1') {
            this.abrirAgregarInventario()
        }
        if (e.key === '2') {
            this.abrirTraspasoEntreAlmacenes()
        }
        if (e.key === '3') {
            this.abrirProductosAlCosto()
        }
    }

    verAgrupacion(id) {
        this.setState({
            modalVerAgrupacion: true,
            modalVerAgrupacionId: id
        })
    }

    cerrarVerAgrupacion() {
        this.setState({
            modalVerAgrupacion: false,
            modalVerAgrupacionId: null
        })
        this.consultarAgrupacionesInsumo(this.state.valor);
    }

    editarAgrupacion(id) {
        this.setState({
            modalEditarAgrupacion: true,
            modalEditarAgrupacionId: id
        })
    }

    cerrarEditarAgrupacion() {
        this.setState({
            modalEditarAgrupacion: false,
            modalEditarAgrupacionId: null
        })
        this.consultarAgrupacionesInsumo(this.state.valor);
    }

    cancelarAgrupacion(value) {
        axios
            .post(
                "agrupaciones/cancelarAgrupacion",
                { agrupacionId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Agrupación cancelada");
                } else if (res.data.success === 1) {
                    message.warning(res.data.message ? res.data.message : "Sucedio un error y no se pudo cancelar la agrupación");
                } else {
                    message.error("Sucedio un error y no se pudo cancelar la agrupación");
                }
                this.consultarAgrupacionesInsumo(this.state.valor);
            });
    }

    render() {
        const columns = [
            {
                title: "Número",
                dataIndex: "numero",
                key: "numero",
                width: "10%",
            },
            {
                title: "Fecha",
                dataIndex: "createdAt",
                responsive: ["md"],
                key: "createdAt",
                render: (value) => moment(value).locale("es").format("DD/MM/YYYY"),
                width: "10%",
            },
            {
                title: "Concepto",
                dataIndex: "concepto",
                responsive: ["md"],
                key: "concepto",
                width: "15%",
                buscar: "concepto",
            },
            {
                title: "Cliente",
                dataIndex: "clienteNombre",
                responsive: ["md"],
                key: "clienteNombre",
                width: "15%",
                buscar: "clienteNombre",
            },
            {
                title: "Piezas",
                dataIndex: "piezas",
                responsive: ["md"],
                key: "piezas",
                render: (value) => {
                    if (Array.isArray(value) && value.length > 0) {
                        let tags = []
                        value.forEach((pieza, index) => {
                            if (pieza.estado !== 0) {
                                tags.push(
                                    <Tag key={index} color="blue">
                                        {pieza?.descripcion?.slice(0, 4)}
                                    </Tag>

                                )
                            }
                        });
                        return tags
                    } else {
                        return null
                    }
                },
                width: "15%",
            },
            {
                title: "Proyecto",
                dataIndex: "proyecto",
                responsive: ["md"],
                key: "proyecto",
                render: (value) => value.nombre,
                width: "5%",
            },
            {
                title: "Cantidad",
                dataIndex: "cantidad",
                key: "cantidad",
                sorter: (a, b) => {
                    if (a.cantidad < b.cantidad) {
                        return -1;
                    }
                    if (a.cantidad > b.cantidad) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => round10Decimals(value).toFixed(4),
                width: "5%",
            },
            {
                title: "Usuario",
                dataIndex: "usuario",
                responsive: ["md"],
                key: "usuario",
                render: (value) => value.nombre,
                width: "10%",
            },
            {
                title: "Acción",
                key: "accion",
                align: "center",
                width: "30%",
                onHeaderCell: () => ({
                    style: { textAlign: 'center', padding: '4px' }
                }),
                onCell: () => ({
                    className: "acciones-sin-hover",
                    style: { textAlign: 'center', padding: '4px' }
                }),
                render: (value, record, index) => {
                    let buttons = [];

                    // Botón Ver
                    buttons.push(
                        <Tooltip title="Ver Agrupación" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                key={`ver-${index}`}
                                type="default"
                                size="small"
                                azul
                                icon={<EyeOutlined />}
                                onClick={() => this.verAgrupacion(value._id)}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    // Botón Editar
                    if (record.estado !== 0) {
                        buttons.push(
                            <Tooltip title="Editar Agrupación" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                <ButtonItem
                                    key={`editar-${index}`}
                                    type="default"
                                    size="small"
                                    cyan
                                    icon={<EditOutlined />}
                                    onClick={() => this.editarAgrupacion(value._id)}
                                >
                                </ButtonItem>
                            </Tooltip>
                        );
                    }

                    // Botón Cancelar
                    if (record.estado !== 0) {
                        buttons.push(
                            <Popconfirm
                                key={`cancelar-${index}`}
                                title="Seguro que quieres cancelar esta agrupación?"
                                onConfirm={() => this.cancelarAgrupacion(value._id)}
                                okText="Si"
                                cancelText="No"
                            >
                                <Tooltip title="Cancelar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        rojo
                                        icon={<DeleteOutlined />}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            </Popconfirm>
                        );
                    }

                    // Tags informativos
                    if (record.etapaNombre) {
                        buttons.push(
                            <Tag key={`etapa-${index}`} color="blue">
                                {record.etapaNombre}
                            </Tag>
                        );
                    }

                    if (record.ventaId) {
                        buttons.push(
                            <Tag key={`venta-${index}`} color="green">
                                V {record.ventaEstadoPago === 0 ? " No Pagada" : (record.ventaEstadoPago === 3 ? " Pagada" : " Parcialmente Pagada")}
                            </Tag>
                        );
                    }

                    if (record.cotizacionNumero) {
                        buttons.push(
                            <Tag key={`cotizacion-${index}`} color="orange">
                                {record.cotizacionNumero}
                            </Tag>
                        );
                    }

                    return <div className="acciones-container">{buttons}</div>;
                },
            }
        ];
        return (
            <>
                <PageHeader
                    title={"Agrupaciones - Insumo"}
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <Space style={{ width: "100%", minWidth: 500 }}>
                            {window.innerWidth > 1000 &&
                                <SegmentedItem
                                    options={[{ label: 'Activos', value: 1 }, { label: 'Ocupados', value: 2 }, { label: 'Todos', value: 3 }]}
                                    onChange={(value) => {
                                        this.consultarAgrupacionesInsumo(value)
                                        this.setState({ valor: value })
                                    }}
                                    value={this.state.valor}
                                />
                            }
                            <SelectInsumosItem
                                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                headersToken={this.props.headersToken}
                                dropdownMatchSelectWidth={600}
                                width={150}
                                placeholder="Insumo"
                                tiposInsumos="inventariablesLotes"
                                value={this.state.insumoId}
                                onChange={(value) => this.onChangeProyectoInsumo(value, this.state.proyectoId)}
                            />
                            <SelectItem
                                placeholder="Proyecto"
                                width={150}
                                onChange={(value) => this.onChangeProyectoInsumo(this.state.insumoId, value)}
                                value={this.state.proyectoId}
                            >
                                <Option value={0}>Todos</Option>
                                {this.state.objetoProyectos}
                            </SelectItem>
                        </Space>
                    }
                />
                <TableItem
                    size="small"
                    dataSource={this.state.todasLotes}
                    columns={columns}
                    pagination={false}
                    loading={this.state.loading}
                    onRow={(record, rowIndex) => {
                        return {
                            onDoubleClick: (event) => {
                                this.verAgrupacion(record._id);
                            },
                        };
                    }}
                />
                <VerAgrupacion
                    visible={this.state.modalVerAgrupacion}
                    cerrarVerAgrupacion={this.cerrarVerAgrupacion.bind(this)}
                    agrupacionId={this.state.modalVerAgrupacionId}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                />
                <EditarAgrupacion
                    visible={this.state.modalEditarAgrupacion}
                    cerrarEditarAgrupacion={this.cerrarEditarAgrupacion.bind(this)}
                    agrupacionId={this.state.modalEditarAgrupacionId}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        taxidermia: state.empresa.taxidermia,
    };
};

export default connect(mapStateToProps)(Agrupaciones);
